import { MutationTree } from "vuex";
import { IncomingTariffsItem, IncomingTariffsState } from "./types";

export const mutations: MutationTree<IncomingTariffsState> = {
  setIncomingTariffs(state, tariffs: IncomingTariffsItem[]) {
    state.incomingTariffs = tariffs;
  },
};
